import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MAIN_MENU_ID } from '../../constants/layout';

type SkipLinkProps = {
  href?: string;
  labelKey?: string;
};

export const SkipLink = ({ href = `#${MAIN_MENU_ID}`, labelKey = 'accessibility.skipToContent' }: SkipLinkProps) => {
  const { t } = useTranslation();

  return (
    <Link
      href={href}
      sx={{
        position: 'absolute',
        top: '-50rem',
        zIndex: 10,
        padding: '0.5rem 1rem',
        backgroundColor: 'primary.main',
        color: 'white',
        textDecoration: 'none',
        fontWeight: 600,
        borderRadius: '0.25rem',
        '&:focus': {
          position: 'absolute',
          top: '0',
          zIndex: 10
        }
      }}
    >
      {t(labelKey)}
    </Link>
  );
};
